import { Directive, inject } from '@angular/core';
import { NG_VALIDATORS, UntypedFormGroup, ValidationErrors, Validator } from '@angular/forms';
import { AffordabilityService } from '../../../services';
import { FormsValidators } from '../validators/forms.validators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[minPropertyValueValidator]',
  // eslint-disable-next-line no-use-before-define
  providers: [{ provide: NG_VALIDATORS, useExisting: MinPropertyValueValidatorDirective, multi: true }],
})
export class MinPropertyValueValidatorDirective implements Validator {
  private readonly affordabilityService = inject(AffordabilityService);

  public validate(formGroup: UntypedFormGroup): ValidationErrors {
    const propertyValueControl = formGroup.controls['propertyValue'];

    if (!propertyValueControl || propertyValueControl.errors) {
      return null;
    }

    const error = FormsValidators.propertyValueValidator(this.affordabilityService.model.propertyAndLoan);

    const errors = !error ? null : { [error]: true };
    propertyValueControl.setErrors(errors);
    return errors;
  }
}
